import type { PageCard } from '@/play/pageTypes'
import { GelCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'gel',
  number: 3,
  title: 'Gel',
  question: 'Does dropping gobs of gel that slump into place right where you drop them feel good?',
  status: 'open',
  accent: '#bdf0d8',
  CardArt: GelCardArt,
}
